/**
 * 设置登录token
 */
export function setLoginToken( token: string) {
    localStorage.setItem('token', token);
}

/**
 * 获取登录token
 */
export function getLoginToken() {
    return localStorage.getItem('token') || "";
}


/**
 * 删除token
 */
export function deleteHeader() {
    localStorage.removeItem('token');
    localStorage.removeItem('user')
    localStorage.removeItem('menu_openKeys')
}

/**
 * 返回请求header
 */
export function getHeaders() {
    return {
        'Authorization': getLoginToken(),
    };
}


